// @file API client for the contributor list endpoint
import FetchableObject from '@@/surface/api/fetchable_object'
import { fetchJson } from '@@/surface/api_fetch'
import type { HashId } from '@@/types'
import { HTTPMethod } from '@padlet/fetch'

interface ContributorListItem {
  hashid: string
  name: string | null
  username: string | null
  avatar: string
  registered_at: string | null
  role: string | null
}

interface ContributorListSection {
  role: string
  contributors: ContributorListItem[]
}

interface ContributorListResponse {
  contributors: ContributorListItem[]
}

class WallContributorListApi extends FetchableObject {
  public static async fetch(wallHashId: HashId): Promise<ContributorListResponse> {
    return await fetchJson(`/api/10/walls/${wallHashId}/contributor-list`, {
      method: HTTPMethod.get,
    })
  }
}

export { WallContributorListApi }
export type { ContributorListItem, ContributorListResponse, ContributorListSection }
